export default "__VITE_ASSET__D8b8UGn2__"